import '../style/SubSection.css';

import myDetails from "../assets/myDetails.json";

import Header from '../components/Header';
import Footer from '../components/Footer';
import BackBtn from '../components/BackBtn';

function Experience() {

    const page_title = "Experince";

    return (
        <div className='home-main'>
            <div className='sub-sec'>
                <Header title={page_title} />
                <div className='body-grid'>
                    {
                        myDetails.experience.map((work) => (
                            <div>
                                <div className="grid-title">{work.title}</div>
                                <hr></hr>
                                <div>
                                    <div className="grid-body-sub-title">
                                        <span>{work.employer}</span>
                                        <span>
                                            {work.end_year
                                                ? work.start_month === work.end_month && work.start_year === work.end_year
                                                    ? `${work.start_month.slice(0, 3)} '${work.start_year.toString().slice(-2)}`
                                                    : `${work.start_month.slice(0, 3)} '${work.start_year.toString().slice(-2)} - ${work.end_month.slice(0, 3)} '${work.end_year.toString().slice(-2)}`
                                                : `${work.start_month.slice(0, 3)} '${work.start_year.toString().slice(-2)} - Present`}
                                        </span>
                                    </div>
                                    <div>{work.desc}</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <BackBtn title={page_title} />
            </div>
            <Footer />
        </div>

    );
}

export default Experience;